import { ReactNode } from 'react';
import { BaseAddress, CollectionPointAddressPart } from '../../utils/checkoutState';
import { joinNames, joinStreetHouseNumber, joinZipCodeCity } from '../../utils/address';

const FormattedAddress = ({
  address,
  title,
}: {
  address: BaseAddress & CollectionPointAddressPart;
  title?: ReactNode;
}) => {
  const { additional, state, collectionPoint } = address;
  return (
    <dl>
      {title}
      <dd>{joinNames(address)}</dd>
      {collectionPoint && <dd>{collectionPoint.description}</dd>}
      {additional && <dd>{additional}</dd>}
      <dd>{joinStreetHouseNumber(address)}</dd>
      <dd>{joinZipCodeCity(address)}</dd>
      {state && <dd>{state}</dd>}
    </dl>
  );
};

export default FormattedAddress;
